import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { OverlayHelper } from '../../../../helper/overlay.helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseCustomDialog } from '../../../shared-module/dialogs/base-custom-dialog';

@Component({
  selector: 'fi-broker-assign-confirm',
  templateUrl: './broker-assign-confirm.component.html',
  styleUrls: ['./broker-assign-confirm.component.scss'],
  standalone: false,
})
export class BrokerAssignConfirmComponent extends BaseCustomDialog implements OnDestroy {
  @Output() popupClosed = new EventEmitter<boolean>();
  alreadyAccepted = false;
  showWarning = false;
  acceptedDate = '';
  acceptedTime = '';

  constructor(
    public dialogRef: MatDialogRef<BrokerAssignConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      alreadyAccepted?: boolean,
      showWarning?: boolean,
      acceptedDate?: string,
      acceptedTime?: string,
    },
  ) {
    super(dialogRef);

    if ( typeof dialogData?.alreadyAccepted === 'boolean' ) {
      this.alreadyAccepted = dialogData.alreadyAccepted;
    }

    if ( typeof dialogData?.showWarning === 'boolean' ) {
      this.showWarning = dialogData.showWarning;
    }

    if ( typeof dialogData?.acceptedDate === 'string' ) {
      this.acceptedDate = dialogData.acceptedDate;
    }

    if ( typeof dialogData?.acceptedTime === 'string' ) {
      this.acceptedTime = dialogData.acceptedTime;
    }
  }

  ngOnDestroy(): void {
    OverlayHelper.unfixBody();
  }

  closeDialog( confirm: boolean = false ): void {
    this.popupClosed.emit(true);
    this.clearClassAndCloseDialog(this.dialogRef);
    this.dialogRef.close(confirm);
  }


  cancel(): void {
    this.clearClassAndCloseDialog(this.dialogRef, false);
  }

  confirm(): void {
    this.clearClassAndCloseDialog(this.dialogRef, true);
  }

  onClosePopup( confirm: boolean = false ): void {
    this.closeDialog(confirm);
  }

  onOverlayClick( event: Event ): void {

    if ( event.target === event.currentTarget ) {
      this.onClosePopup();
    }
  }
}
